import { CoordinatesModel } from "../../general";

export interface Document {
  name: string;
  type: string;
  url: string;
  expiry?: string;
}

export interface PrimaryDetails {
  make: string;
  model: string;
  variant: string;
  vinNumber: string;
}

export interface SecondaryDetails {
  make: string;
  model: string;
  variant: string;
  engineType: string;
  numberofCylinder: number;
  wheelType: string;
  makeYear: string;
}

export interface EntitySummaryDetails {
  averageSpeed: string;
  averageMileage: string;
  distanceCovered: string;
}

export interface EntityScoreParameters {
  idling: string;
  speeding: string;
  hardAcceleration: string;
  hardBrakes: string;
  vehicleScore: number;
}

export interface IssueType {
  engine?: {
    status: string;
    errorCode?: null;
  };
  coolent?: {
    status: string;
    errorCode: number[];
  };
  battery?: {
    status: string;
    errorCode: number[];
  };
}

export interface EntityHealthDetails {
  issueType: IssueType[];
}

export interface EntityBehaviour {
  safeDriving: number;
  overSpeeding: number;
  suddenBraking: number;
  hardAcceleration: number;
  fastCornering: number;
}

export interface ActiveAlertDetails {
  date: string;
  mechanicalAlertCount: number;
  trafficAlertCount: number;
}

export interface MapDataSet {
  value: number;
  date: string;
}

export interface Map {
  type: string;
  unit: string;
  dataSet: MapDataSet[];
}

export interface EntityUtilization {
  running: number;
  idle: number;
  stopped: number;
}

export interface CertificateDetails {
  insurance: string;
  pollution: string;
  rc: string;
}

export interface Site {
  _id: string;
  name: string;
}

export interface ZoneDetails {
  name: string;
  centroid: CoordinatesModel;
  geoFence: { 
    geometry: {
      coordinates?: CoordinatesModel[];
      center?: CoordinatesModel;
      radius?: number;
      type: string;
    };
    properties: {
      strokeColor: string;
      strokeOpacity: number;
      strokeWeight: number;
      fillOpacity: number;
      fillColor: string;
      labelColor: string;
    }
  }
  id: string;
  radius?: number | string;
}

export interface Device {
  _id: string;
  deviceName: string;
}

export interface Entity {
  _id: string;
  name: string;
  type: number;
  category: string;
  uniqueId: string;
  documents: Document[];
  primaryDetails: PrimaryDetails;
  secondaryDetails: SecondaryDetails;
  entitySummaryDetails: EntitySummaryDetails;
  entityScoreParameters: EntityScoreParameters;
  entityHealthDetails: EntityHealthDetails;
  entityBehaviour: EntityBehaviour;
  activeAlertDetails: ActiveAlertDetails[];
  map: Map[];
  entityUtilization: EntityUtilization;
  image: string;
  thumbnail?: string | null;
  certificateDetails: CertificateDetails;
  cause: string;
  remarks: string;
  site: Site;
  zoneDetails: ZoneDetails[];
  mappingId: string;
  device: Device;
}
